import { IClassname } from '@/lib/shared/model/classname';

export const BBQ = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0285 11.5273C23.1152 11.5272 23.2011 11.5448 23.2809 11.579C23.3607 11.6131 23.4326 11.6632 23.4924 11.7261C23.5522 11.789 23.5986 11.8634 23.6286 11.9448C23.6587 12.0262 23.6719 12.1129 23.6674 12.1995C23.4894 14.1099 22.6046 15.885 21.1864 17.1772C19.7681 18.4694 17.9186 19.1857 15.9999 19.1857C14.0813 19.1857 12.2317 18.4694 10.8135 17.1772C9.39522 15.885 8.51045 14.1099 8.33241 12.1995C8.32789 12.1129 8.34108 12.0262 8.37117 11.9448C8.40125 11.8634 8.4476 11.789 8.50739 11.7261C8.56718 11.6632 8.63915 11.6131 8.71892 11.579C8.79869 11.5448 8.88459 11.5272 8.97137 11.5273H23.0285Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5273 8.97121C12.0482 8.45458 12.385 7.78107 12.4857 7.05434C12.4857 5.52723 10.5688 4.7477 10.5688 3.22059C10.6696 2.49385 11.0063 1.82034 11.5273 1.30371"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4726 8.97121C20.9935 8.45458 21.3303 7.78107 21.431 7.05434C21.431 5.52723 19.5142 4.7477 19.5142 3.22059C19.6149 2.49385 19.9516 1.82034 20.4726 1.30371"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9999 8.97121C16.5209 8.45458 16.8576 7.78107 16.9584 7.05434C16.9584 5.52723 15.0415 4.7477 15.0415 3.22059C15.1422 2.49385 15.479 1.82034 15.9999 1.30371"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41553 30.6956L12.3336 18.2666"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5843 30.6956L19.6663 18.2666"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7582 26.8623H8.2417"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
